import React from "react"
import PropTypes from "prop-types"
import OptionListItem from "./OptionListItem"

class OptionList extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      currentOptionList: props.currentOptionList,
      optionLists: props.optionLists,
      controlOption: props.controlOption
    }
    this.controlOption = this.controlOption.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      currentOptionList: nextProps.currentOptionList,
      optionLists: nextProps.optionLists
    })
  }

  controlOption(option, control, index){
    this.state.controlOption(option, control, index);
  }

  renderOptionList(){
    if(this.state.currentOptionList === "new-option-list" || this.state.currentOptionList === ""){
      return []
    }
    else{
      let options = this.state.optionLists.filter(e=>{ return e.listName== this.state.currentOptionList })[0].options;
      let optionList;
      if(options){
        optionList = options.map((option, i) =>
            <OptionListItem
              option={option}
              key={i}
              controlOption={(option,control)=>{ this.controlOption(option, control, i);}}
            />
        );
      }
      else{
        optionList = [];
      }
      return optionList
    }
  }

  render () {
    return this.renderOptionList();
  }
}

export default OptionList
